import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import Select from 'react-select';
import OrderForm from './OrderForm';
import { useNavigate } from 'react-router-dom';
import './StoreTable.css'; 

Modal.setAppElement('#root');

const StoreTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  // const [showOrderForm, setShowOrderForm] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [isAddMode, setIsAddMode] = useState(false);

  const [filters, setFilters] = useState({
  Region: '', Retailer: '', Location: '', "Brand name": '', Media: '', Cataegeory: '',
  "Assest Element Type": '', 'QTY': '', "Print size (Height mm)": '', "Visible Width mm": '',
  "Assest Element Name": '', "Rate Per Sq. Ft": '', "Print size (Width mm)": '',
  "Printing Cost": '', "Reece Completion Date": '', "Updated Visual Name": ''
});

  useEffect(() => {
    axios.get('https://stores.comart.in:5000/stores')
      .then(response => setData(response.data))
      .catch(err => console.error('Failed to fetch data:', err));
  }, []);

  const openImageDialog = (image) => setSelectedImage(image);
  const closeImageDialog = () => setSelectedImage(null);

  const getUniqueOptions = (field) => {
    const values = Array.from(new Set(data.map(item => item[field]).filter(Boolean)));
    return values.map(v => ({ label: String(v), value: String(v) }));
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      axios.delete(`https://stores.comart.in:5000/stores/${id}`)
        .then(() => setData(prev => prev.filter(item => item.id !== id)))
        .catch(err => alert('Delete failed'));
    }
  };

  const handleEdit = (item) => {
    setEditItem({ ...item });
    setIsAddMode(false);
    setEditModalOpen(true);
  };

  const handleAdd = () => {
    const blank = Object.keys(data[0] || {}).reduce((acc, key) => {
      acc[key] = key === 'Sr. No' ? data.length + 1 : '';
      return acc;
    }, {});
    setEditItem(blank);
    setIsAddMode(true);
    setEditModalOpen(true);
  };

  const handleSaveEdit = () => {
    if (isAddMode) {
      axios.post('https://stores.comart.in:5000/stores', editItem)
        .then(res => setData(prev => [...prev, res.data]))
        .catch(err => alert('Add failed'));
    } else {
      axios.put(`https://stores.comart.in:5000/stores/${editItem.id}`, editItem)
        .then(res => setData(prev => prev.map(item => item.id === editItem.id ? res.data : item)))
        .catch(err => alert('Update failed'));
    }
    setEditModalOpen(false);
  };

 const handleImageUpload = (e, key) => {
  const file = e.target.files[0];
  if (file) {
    const formData = new FormData();
    formData.append("image", file);

    // 🧠 Decide where to upload based on key
    const type = key === "Recce Images" ? "recce" : "updated";

    axios
      .post(`https://stores.comart.in:5000/upload-image?type=${type}`, formData)
      .then((res) => {
        const imagePath = res.data.imagePath; // e.g. "./images/264.jpg"
        setEditItem((prev) => ({ ...prev, [key]: imagePath }));
      })
      .catch((err) => {
        console.error("Image upload failed", err);
        alert("Image upload failed");
      });
  }
};


  const filteredData = data.filter(item =>
    Object.entries(filters).every(([key, value]) => {
      const fieldValue = item[key];
      if (value === '') return true;
      if (!isNaN(value) || typeof fieldValue === 'number') {
        return String(fieldValue) === String(value);
      }
      return (
        typeof fieldValue === 'string' &&
        String(fieldValue).toLowerCase().includes(String(value).toLowerCase())
      );
    })
  );

  const headers = [...(data[0] ? Object.keys(data[0]).filter(k => k !== 'id') : []), 'Actions'];

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '15px' }}>Store Visual Tracker</h2>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '20px' }}>
        {Object.keys(filters).map(key => (
          <div key={key} style={{ width: '200px' }}>
            <Select
              options={getUniqueOptions(key)}
              placeholder={`Filter by ${key}`}
              isClearable
              value={filters[key] ? { label: filters[key], value: filters[key] } : null}
              onChange={(selected) => setFilters(prev => ({ ...prev, [key]: selected ? selected.value : '' }))}
            />
          </div>
        ))}
        <button
          onClick={() => setFilters(Object.fromEntries(Object.keys(filters).map(k => [k, ''])))}
          style={{ padding: '6px 14px', backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', height: '40px', alignSelf: 'center' }}
        >
          Clear All
        </button>
      </div>

      <div style={{ marginTop: '20px', textAlign: 'right' }}>
        {/* <button onClick={() => setShowOrderForm(true)} style={{ padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}>+ Add Order</button> */}
        <button onClick={() => navigate("/add-order")} style={{ padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}>
  + Add Order
</button>
        <button onClick={handleAdd} style={{ padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer', marginLeft: '10px' }}>+ Add Record</button>
        <button onClick={() => navigate("/kanban")} style={{ padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer', marginLeft: '10px' }}>+ Show Progress</button>
      </div>

      <div style={{ overflowX: 'auto', border: '1px solid #ccc', borderRadius: '5px', maxHeight: '75vh', marginTop: '20px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
          <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1 }}>
            <tr>
              {headers.map(col => (
                <th
                  key={col}
                  style={{
                    padding: '8px',
                    borderBottom: '2px solid #333',
                    fontWeight: 'bold',
                    backgroundColor: '#e9ecef',
                    whiteSpace: 'nowrap',
                    ...(col === 'Actions' ? {
                      position: 'sticky',
                      right: 0,
                      zIndex: 2,
                      background: '#e9ecef'
                    } : {})
                  }}
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, idx) => (
              <tr key={item.id || idx} style={{ backgroundColor: idx % 2 === 0 ? '#ffffff' : '#f7f7f7' }}>
                {headers.filter(h => h !== 'Actions').map(col => {
                  if (col === 'Recce Images' || col === 'Updated Visual image') {
                    const imgPath = item[col];
                    const shouldShow = col === 'Updated Visual image' ? item['Visual Change Date'] : true;
                    return (
                      <td key={col} style={{ padding: '6px', textAlign: 'center' }}>
                      {imgPath && shouldShow ? (
                        <img
                        src={`https://stores.comart.in:5000${imgPath.replace('./', '/')}`}
                        alt="preview"
                        style={{ width: '50px', cursor: 'pointer' }}
                        onClick={() => openImageDialog(`https://stores.comart.in:5000${imgPath.replace('./', '/')}`)}
                        />
                      ) : (
                        <span></span>
                      )}
                      </td>
                    );
                  }
                  return <td key={col} style={{ padding: '6px' }}>{item[col]}</td>;
                })}
                <td style={{
                  padding: '6px',
                  position: 'sticky',
                  right: 0,
                  background: '#fff',
                  zIndex: 1
                }}>
                  {/* <button onClick={() => handleEdit(item)} style={{ marginRight: '10px' }}>Edit</button>
                  <button onClick={() => handleDelete(item.id)}>Delete</button> */}
                 <button
  onClick={() => handleEdit(item)}
  style={{
    padding: '6px 12px',
    backgroundColor: '#0d6efd',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
    marginRight: '6px'
  }}
>
  Edit
</button>

<button
  onClick={() => handleDelete(item.id)}
  style={{
    padding: '6px 12px',
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold'
  }}
>
  Delete
</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

 <Modal
  isOpen={editModalOpen}
  onRequestClose={() => setEditModalOpen(false)}
  contentLabel="Edit Record"
  style={{
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000,
    },
    content: {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '80%',
      height: '95vh',         // ✅ taller height
      maxHeight: '95vh',
      overflow: 'auto',
      borderRadius: '8px',
      border: '1px solid #ccc',
      padding: '20px',
      zIndex: 1001,
    }
  }}
>


        <h3>{isAddMode ? 'Add New Record' : 'Edit Record'}</h3>
       {editItem && (
<form
  style={{
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gap: '20px',
  }}
>
  {Object.keys(editItem).filter(key => key !== 'id').map((key) => (
    <div key={key} style={{ display: 'flex', flexDirection: 'column' }}>
      <label style={{ fontWeight: 'bold', marginBottom: '4px' }}>{key}</label>
      {key.toLowerCase().includes('image') ? (
        <>
          {editItem[key] && (
            <img
              src={editItem[key]}
              alt="preview"
              style={{ width: '80px', height: 'auto', marginBottom: '6px' }}
            />
          )}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleImageUpload(e, key)}
          />
        </>
      ) : (
        <input
          type="text"
          value={editItem[key] || ''}
          onChange={(e) =>
            setEditItem((prev) => ({ ...prev, [key]: e.target.value }))
          }
          style={{ padding: '8px', fontSize: '14px' }}
        />
      )}
    </div>
  ))}

  <div
    style={{
      gridColumn: '1 / span 2',
      textAlign: 'center',
      marginTop: '20px',
    }}
  >
    <button
      type="button"
      onClick={handleSaveEdit}
      style={{
        marginRight: '10px',
        backgroundColor: '#28a745',
        color: 'white',
        padding: '8px 16px',
        border: 'none',
        borderRadius: '4px',
        fontWeight: 'bold',
      }}
    >
      Save
    </button>
    <button
      type="button"
      onClick={() => setEditModalOpen(false)}
      style={{
        padding: '8px 16px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        fontWeight: 'bold',
      }}
    >
      Cancel
    </button>
  </div>
</form>

)}

      </Modal>

      {/* <Modal isOpen={showOrderForm} onRequestClose={() => setShowOrderForm(false)} style={{ overlay: { backgroundColor: 'rgba(0, 0, 0, 0.6)' }, content: { top: '0', left: '0', right: '0', bottom: '0', width: '100vw', height: '100vh', padding: '20px', border: 'none', borderRadius: '0px', overflow: 'auto', backgroundColor: '#fff' } }}>
        <OrderForm />
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <button onClick={() => setShowOrderForm(false)} style={{ padding: '10px 20px' }}>Close</button>
        </div>
      </Modal> */}

      {selectedImage && (
  <Modal
    isOpen={!!selectedImage}
    onRequestClose={closeImageDialog}
    style={{
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 2000, // higher than edit modal
      },
      content: {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '90vh',
        maxWidth: '90vw',
        overflow: 'auto',
        borderRadius: '8px',
        zIndex: 2001, // ensure it's on top
      }
    }}
  >
    <img src={selectedImage} alt="Preview" style={{ maxWidth: '100%', maxHeight: '80vh' }} />
    <div style={{ textAlign: 'center', marginTop: '10px' }}>
      <button
        onClick={closeImageDialog}
        style={{
          padding: '10px 20px',
          backgroundColor: '#dc3545',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Close
      </button>
    </div>
  </Modal>
)}

    </div>
  );
};

export default StoreTable;
